var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icone_Men",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.433,
    height: 30.453,
    viewBox: "0 0 10.433 10.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M161.118,16.981c-.187.122-.367.259-.564.362a3.832,3.832,0,0,1-4.276-.261,3.9,3.9,0,0,1,4.5-6.356c.084.055.163.117.254.183l2.615-2.615c-.051,0-.092-.006-.131-.006-.4,0-.8,0-1.193,0a.436.436,0,1,1-.006-.867q1.179,0,2.358,0a.435.435,0,0,1,.472.476q0,1.179,0,2.358a.435.435,0,1,1-.867,0c0-.439,0-.88,0-1.344l-2.625,2.625a3.914,3.914,0,0,1,.025,4.844.421.421,0,0,0-.037.075Zm-.368-5.165a3.034,3.034,0,1,0,.021,4.292A3.033,3.033,0,0,0,160.751,11.816Z",
    transform: "translate(-154.718 -7.418)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMen);
export default __webpack_public_path__ + "static/media/icon_men.8fc055f8a1dadf494dd832d256c656cb.svg";
export { ForwardRef as ReactComponent };